import { useTranslation } from 'react-i18next'

import GoogleAdwordsImage from 'assets/images/google-adwords.svg'

import styles from './AuthorizationButton.module.scss'

const GoogleLogin = () => {
  const { t } = useTranslation('connections')
  return (
    <div className={styles.google}>
      <div>
        <GoogleAdwordsImage />
        <span>{t('setup.authorization.googleAdwords.signIn')}</span>
      </div>
    </div>
  )
}

export default GoogleLogin
